import axiosInstance from '../../services/axiosInstance';
import { MaintenanceNotice, MaintenanceRoleOption, MaintenanceSettings } from './types';

export const DEFAULT_MAINTENANCE_SETTINGS: MaintenanceSettings = {
  enabled: false,
  displayType: 'tape',
  severity: 'warning',
  title: '',
  message: '',
  startsAt: null,
  endsAt: null,
  dismissible: false,
  audienceRoleIds: [],
};

export const getMaintenanceSettings = async (): Promise<MaintenanceSettings> => {
  const response = await axiosInstance.get<MaintenanceSettings>('/api/maintenance/settings');
  return response.data;
};

export const updateMaintenanceSettings = async (
  settings: MaintenanceSettings
): Promise<MaintenanceSettings> => {
  const response = await axiosInstance.put<MaintenanceSettings>('/api/maintenance/settings', settings);
  return response.data;
};

export const getMaintenanceRoleOptions = async (): Promise<MaintenanceRoleOption[]> => {
  const response = await axiosInstance.get<MaintenanceRoleOption[]>('/api/maintenance/roles');
  return response.data;
};

export const getMaintenanceNotice = async (): Promise<MaintenanceNotice> => {
  const response = await axiosInstance.get<MaintenanceNotice>('/api/maintenance/notice');
  return response.data;
};
